<template>
  <ODialog ref="dialog" :maxWidth="dialogWidth" hideWhenLoading>
    <v-card>
      <ODialogBar title="Importar ScreenSets" @close="dismiss" />

      <v-window v-model="currentTab">
        <v-window-item :value="1">
          <v-card-text class="pa-6">
            <p>
              Este utilitário permite importar um ou mais ScreenSets a
              partir de um arquivo JSON exportado de outro sistema.
            </p>

            <v-alert outlined color="oderon">
              Nota: Por segurança, a aplicabilidade dos objetos importados é
              zerada.
            </v-alert>

            <p>Clique no botão abaixo para selecionar o arquivo de origem.</p>

            <o-row>
              <v-spacer />
              <v-btn text large color="primary" @click="loadRows">
                Selecionar Arquivo
              </v-btn>
            </o-row>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2" v-if="prepared != null">
          <v-simple-table fixed-header height="400px">
            <thead>
              <tr>
                <th>
                  <OCheckbox :value="allSelected" @input="selectAll" />
                </th>
                <th>Código</th>
                <th>Nome</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, idx) in prepared"
                :key="idx"
              >
                <td><OCheckbox v-model="row.isSelected" /></td>
                <td>{{ row.code }}</td>
                <td>{{ row.name }}</td>
              </tr>
            </tbody>
          </v-simple-table>

          <ODialogButtons
            class="pa-6"
            @cancel="dismiss"
            @apply="doImport()"
            :txtApply="`Importar ${selectedCount} objetos`"
          />
        </v-window-item>
      </v-window>
    </v-card>
  </ODialog>
</template>

<script>
import { openFile } from 'oderon-vue/utils'
import { ScreenSet } from '@/models'

function firstAvailable(rows, name, n = 1) {
  let name1 = `${name} (${n})`
  if (!rows.some((x) => x.name == name1)) return name1
  return firstAvailable(rows, name, n + 1)
}

export default {
  components: {
    OCheckbox: require('oderon-vue/cpts/OCheckbox').default
  },
  data() {
    return this.reset()
  },
  computed: {
    allSelected() {
      return this.prepared != null && this.prepared.every(r => r.isSelected)
    },
    selectedCount() {
      if (this.prepared == null) return 0
      return this.prepared.filter(x => x.isSelected).length
    }
  },
  methods: {
    reset() {
      return {
        currentTab: 1,
        prepared: null,
        dialogWidth: 400,
        selectedIds: [],
      }
    },

    selectAll(x) {
      this.prepared.forEach(r => this.$set(r, 'isSelected', x))
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    open() {
      Object.assign(this, this.reset())
      return this.$refs.dialog.$open()
    },

    async loadRows() {
      let str = await openFile()
      if (str != null) {
        this.$refs.dialog.$loading(async () => {
          let rows = JSON.parse(str)
          let existing = await ScreenSet.findAll()

          for ( let r of rows ) {
            delete r.id
            r.name = firstAvailable(existing, r.name)
          }

          this.prepared = rows
          this.currentTab = 2
          this.dialogWidth = 800
        })
      }
    },

    doImport() {
      if (this.selectedCount > 0) {
        let rows = this.prepared.filter(x => x.isSelected)
        this.$refs.dialog.$apply(rows)
      }
    }
  }
}
</script>

<style></style>
